import React from 'react';

import {
    DataFeedsMonochromeIcon,
    ExploitsAndKevMonochromeIcon,
    McpForAiAgentsMonochromeIcon,
    SecurityAndAutomationMonochromeSdkIcon,
    WhiteLabelLargeMonochromeIcon
} from 'pages/Landings/components/Icons';
import Title from 'pages/Landings/components/Title';

import Card from './components/Card';
import useStyles from './styles';

interface Props {
    className?: string;
}

const SolutionsSection: React.FC<Props> = ({ className }) => {
    const { cx, classes } = useStyles();
    return (
        <section className={cx(classes.root, className)}>
            <Title variant="h2">{'Solutions'}</Title>
            <div className={classes.cards}>
                <Card
                    icon={<WhiteLabelLargeMonochromeIcon />}
                    title="White Label"
                    to="/solutions/white-label"
                    description={'Build Faster, Earn More, and Innovate Freely'}
                    className={classes._spanned}
                    iconClassName={classes.whiteLabelIcon}
                />
                <Card
                    icon={<DataFeedsMonochromeIcon />}
                    title="Data Feeds"
                    to="/solutions/data-feeds"
                    description={'Bring Vulnerability Intelligence Into Your Stack'}
                />
                <Card
                    icon={<McpForAiAgentsMonochromeIcon />}
                    title="MCP for AI Agents"
                    to="/solutions/mcp-for-ai-agents"
                    description={'Ship Trustworthy Security Answers, Fast'}
                />
                <Card
                    icon={<SecurityAndAutomationMonochromeSdkIcon />}
                    title="Security Automation SDK"
                    to="/solutions/security-automation-sdk"
                    description={'Product-Ready Context from 200+ Sources'}
                />
                <Card
                    icon={<ExploitsAndKevMonochromeIcon />}
                    title="Exploits & KEV"
                    to="/solutions/exploits-and-kev"
                    description={'Prioritize What’s Actively Dangerous'}
                />
            </div>
        </section>
    );
};

export default SolutionsSection;
